export function getGenerateOtpEndpoint(): string {
    return '/generate/otp';
}

export function getValidateOtpEndpoint(): string {
    return '/validate/otp';
}
